import { useEffect, useRef } from 'react';
import { Bounce, ToastContainer, toast } from 'react-toastify';
import { useGlobalContext } from '~/context/GlobalContext';
import styles from './AlertContainer.module.css';

function AlertContainer() {
  const { context } = useGlobalContext();

  const isOnlineRef = useRef<boolean>(navigator.onLine);

  // Zapisujemy Twoją nazwę w refie, aby ominąć problem "stale closures"
  const myNameRef = useRef<string | undefined>(context.user?.name);

  useEffect(() => {
    myNameRef.current = context.user?.name;
  }, [context.user?.name]);

  useEffect(() => {
    const handleNotActive = (e: any) => {
      toast.error("Zostałeś wylogowany z powodu braku aktywności.", {
        position: "bottom-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        transition: Bounce,
      });
    };

    const handleConnectionChange = () => {
      const online = navigator.onLine;
      if (online !== isOnlineRef.current) {
        isOnlineRef.current = online;
        if (online) {
          toast.info("Połączenie z internetem zostało przywrócone.", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.warn("Utracono połączenie z internetem.", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    };

    // --- NOWY NASŁUCHIWACZ NA OZNACZENIA ---
    const handleNewMessage = (e: any) => {
      const data = e.detail;

      // Sprawdzamy czy to event nowej wiadomości
      if (data?.event === 'serverMessage' && data?.message) {
        const msg = data.message;
        const myName = myNameRef.current;

        // Jeśli mamy swoją nazwę, wiadomość nie jest od nas i posiada tekst
        if (myName && !msg.isMine && msg.userText) {
          const mentionText = `@${myName}`;

          // Sprawdzamy, czy w tekście znajduje się @MojaNazwa
          if (msg.userText.includes(mentionText)) {

            toast(
              <div>
                <strong style={{ color: 'var(--messageContainer_color2)', fontWeight: 800 }}>
                  {msg.userName}
                </strong> wspomniał o Tobie!
              </div>,
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                transition: Bounce,
                icon: <svg
                  className={styles.bubbleIcon}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: 'scaleX(-1)' }}
                >
                  <path
                    d="M21 11.5C21 15.6421 17.4183 19 13 19C11.753 19 10.5756 18.7331 9.51322 18.2544L5 20L6.5 16.5C5.56303 15.1437 5 13.394 5 11.5C5 7.35786 8.58172 4 13 4C17.4183 4 21 7.35786 21 11.5Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle cx="10" cy="11.5" r="1" fill="currentColor" />
                  <circle cx="13" cy="11.5" r="1" fill="currentColor" />
                  <circle cx="16" cy="11.5" r="1" fill="currentColor" />
                </svg>,
                style: {
                  backgroundColor: 'var(--bg-message)',
                  color: 'var(--color-message)',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  border: '1px solid rgba(128, 128, 128, 0.15)',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }
              }
            );
          }
        }
      }
    };

    const handleBanWarning = (e: any) => {
      const data = e.detail;
      toast.warn(data?.message || 'Ostrzeżenie od moderatora: Twoje konto może zostać zablokowane.', {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        transition: Bounce,
      });
    };

    // eventy online/offline z przeglądarki
    window.addEventListener('online', handleConnectionChange);
    window.addEventListener('offline', handleConnectionChange);

    // fallback – Safari czasem nie wywołuje eventów → sprawdzamy co 15s
    const interval = setInterval(handleConnectionChange, 15000);

    // nasłuch na wylogowanie
    window.addEventListener('notActive', handleNotActive);

    // nasłuch na nową wiadomość
    window.addEventListener('audioNotification', handleNewMessage);

    // nasłuch na ostrzeżenie moderatora
    window.addEventListener('banWarningReceived', handleBanWarning);

    return () => {
      window.removeEventListener('online', handleConnectionChange);
      window.removeEventListener('offline', handleConnectionChange);
      window.removeEventListener('notActive', handleNotActive);
      window.removeEventListener('audioNotification', handleNewMessage);
      window.removeEventListener('banWarningReceived', handleBanWarning);
      clearInterval(interval);
    };
  }, []);

  return (
    <div data-component="AlertContainer">
      <ToastContainer />
    </div>
  );
};

export default AlertContainer;